import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["location", "zone"]
  static values = { allLocations: Boolean }

  connect() {
    this.options = Array.from(this.zoneTarget.options, option => option.cloneNode(true))
    this.update()
  }

  update() {
    const selected = this.zoneTarget.value
    const location = this.locationTarget.value
    const options = this.options.filter(option => !option.value ||
      (!location && this.allLocationsValue) || option.dataset.locationId === location)
    this.zoneTarget.replaceChildren(...options.map(option => option.cloneNode(true)))
    this.zoneTarget.value = options.some(option => option.value === selected) ? selected : ""
  }
}
